import { FC, ReactNode } from "react"

import { baseAuthFooterText } from "./AuthFooterText.css"

export const AuthFooterText: FC<{ children: ReactNode }> = ({ children }) => (
  <div className={baseAuthFooterText}>{children}</div>
)
